
import React from 'react';
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import OpeningHoursForm from './OpeningHoursForm';
import { WeeklyHours, createDefaultOpeningHours } from '@communitly/shared';
import { useTimeFormatParameters } from '@/hooks/useParameters';

interface BusinessRegistrationOpeningHoursFormProps {
  formData: { opening_hours?: WeeklyHours };
  updateFormData: (data: { opening_hours: WeeklyHours }) => void;
  onNext: () => void;
  onPrev: () => void;
}

const BusinessRegistrationOpeningHoursForm: React.FC<BusinessRegistrationOpeningHoursFormProps> = ({
  formData,
  updateFormData,
  onNext,
  onPrev
}) => {
  const { timeDisplayFormat } = useTimeFormatParameters();

  const handleOpeningHoursChange = (hours: WeeklyHours) => {
    updateFormData({ opening_hours: hours });
  };

  // Initialize with default hours if not set
  const openingHours = formData.opening_hours || createDefaultOpeningHours();

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-2xl font-semibold mb-2">Business Hours</h2>
        <p className="text-muted-foreground">
          Set your business opening hours for each day of the week. This helps customers know when you're available.
          {timeDisplayFormat === '12' ? ' (Using 12-hour format)' : ' (Using 24-hour format)'}
        </p>
      </div>

      <OpeningHoursForm 
        openingHours={openingHours}
        onChange={handleOpeningHoursChange}
      />

      <div className="flex justify-between pt-6">
        <Button
          type="button"
          variant="outline"
          onClick={onPrev}
        >
          Previous
        </Button>
        <Button
          type="button"
          onClick={onNext}
        >
          Next: Discount
        </Button>
      </div>
    </div>
  );
};

export default BusinessRegistrationOpeningHoursForm;
